import common from './common';
import tools from './tools'; //工具
import http from './ajax';
import notice from './notice';
let weixin = (function() {
  return {
    default: {
      title: '',
      desc: '',
      href: location.href
    },
    share: function(p) {
      //微信分享
      var param = p ? p : this.default;
      var img = param.logo;
      var imgUrl = img ? img : location.origin + '/m/bdgj/public/images/share_logo.jpg'; //默认图片
      if (!tools.isWeiXin()) return;
      this.getJssdk(function(data) {
        var config = {
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: common.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.noncestr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名，见附录1
          openTagList: ['wx-open-launch-weapp'],
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'updateTimelineShareData', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        };
        wx.config(config);
        wx.ready(function() {
          const params = {
            title: param.title,
            desc: param.content,
            link: param.link,
            imgUrl: imgUrl,
            success: function() {
              //layer.msg('分享成功！');
            },
            cancel: function() {
              notice.msg('取消分享！');
            },
            fail: function(res) {
              console.log(JSON.stringify(res));
              // notice.alert(JSON.stringify(res));
            }
          };
          wx.showOptionMenu();
          // 旧版朋友圈
          wx.onMenuShareTimeline(params);
          // 旧版朋友
          wx.onMenuShareAppMessage(params);
          //分享到朋友圈
          wx.updateTimelineShareData(params);
          //分享给朋友
          wx.updateAppMessageShareData(params);
          //alert('已注册获取“发送给朋友”状态事件');
        });
        wx.error(function(res) {
          console.log(res);
        });
      });
    },
    hideMenu() {
      //隐藏微信地址栏自带工具栏
      if (!tools.isWeiXin()) return;
      this.getJssdk(function(data) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: common.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.noncestr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名，见附录1
          openTagList: ['wx-open-launch-weapp'],
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'updateTimelineShareData', 'updateAppMessageShareData', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function() {
          wx.hideOptionMenu();
        });

        wx.error(function(res) {
          console.log(res);
          // alert(JSON.stringify(res));
        });
      });
    },
    //获取地址栏参数
    getQueryStringByName: function(name) {
      var result = location.search.match(new RegExp('[?&]' + name + '=([^&]+)', 'i'));
      if (result == null || result.length < 1) {
        return '';
      }
      return result[1];
    },
    //判断是否存才hash
    hasHash: function() {
      if (window.location.hash && window.location.hash.length > 0) {
        if (this.isAL() && window.location.hash.split('?').length > 1) {
          return '';
        }
        return window.location.hash;
      }
      return '';
    },
    //删除地址栏参数
    delQueStr: function(url, ref) {
      var str = '';
      if (url.indexOf('?') != -1) {
        str = url.substr(url.indexOf('?') + 1);
      } else {
        return url;
      }
      var arr = '';
      var returnurl = '';
      var setparam = '';
      if (str.indexOf('&') != -1) {
        arr = str.split('&');
        for (let i in arr) {
          if (arr[i].split('=')[0] != ref) {
            returnurl = returnurl + arr[i].split('=')[0] + '=' + arr[i].split('=')[1] + '&';
          }
        }
        return url.substr(0, url.indexOf('?')) + '?' + returnurl.substr(0, returnurl.length - 1) + this.hasHash();
      } else {
        arr = str.split('=');
        if (arr[0] == ref) {
          return url.substr(0, url.indexOf('?')) + this.hasHash();
        } else {
          return url;
        }
      }
    },
    //获取微信授权地址
    wechat_redirect_url: function(params) {
      var wxappid = common.appId; //appid
      if (params.appid) {
        wxappid = params.appid;
      }
      var fromurl = '';
      var tempHref = location.href;
      var authText = "snsapi_base";
      if(params.openModal){
        authText = "snsapi_userinfo";
      }
      tempHref = this.delQueStr(tempHref, 'code');
      tempHref = this.delQueStr(tempHref, 'state');
      //如果当前访问域名不在安全域名内,则跳转到个人中心的登录跳转页
      fromurl = encodeURIComponent(tempHref);
      var url =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        wxappid +
        '&redirect_uri=' +
        fromurl +
        '&response_type=code&scope=' +
        authText +
        '&state=' +
        authText +
        '#wechat_redirect';
      return url;
    },
    // 跳转授权
    jumpAuth: function() {
      var appid = common.appId;
      var redirect_url = this.wechat_redirect_url({ appid }); //获取授权地址
      window.location.replace(redirect_url);
    },
    wxmplogin: function(params, callback) {
      if (localStorage.bdgj_openid) {
        let userInfo = {};
        try {
          userInfo = JSON.parse(localStorage.bdgj_wxInfo);
        } catch (e) {
          console.log('读取本地微信用户信息失败', e);
        }
        userInfo.openId = localStorage.bdgj_openid;
        if (userInfo.hasOwnProperty('nickname')) {
          callback && callback(userInfo);
          return;
        }
      }
      var code = this.getQueryStringByName('code');
      var state = this.getQueryStringByName('state');
      var authUrl = '/api/policyManager/wx/silentAuth';// 基础授权接口
      if (state == 'snsapi_userinfo') {
        authUrl = '/api/policyManager/wx/auth';
      }
      var appid = common.appId;
      if (params.appid) {
        appid = params.appid;
      }
      if (!code) {
        callback && callback({});
      } else {
        http({
          url: authUrl,
          type: 'PUT',
          hideAlert: true,
          data: {
            code: code,
            state: state,
            appid: appid
          }
        })
          .then((result, er) => {
            if (result != null && result.hasOwnProperty('data') && result.data != '') {
              if (state == 'snsapi_userinfo' && result.data.openId) {
                localStorage.setItem('bdgj_openid', result.data.openId);
                localStorage.setItem('bdgj_wxInfo', JSON.stringify(result.data));
              }else if(state == 'snsapi_base') {
                localStorage.setItem('bdgj_openid', result.data);
              }
            }
            callback && callback(result.data);
          })
          .catch(result => {
            let count = Number(sessionStorage.getItem('wxAuthCount')) || 0;
            count++;
            sessionStorage.setItem('wxAuthCount', count);
            // 3次异常后不再调用
            if(count > 3) {
              callback && callback();
              return;
            }
            var redirect_url = this.wechat_redirect_url(params); //获取授权地址
            window.location.replace(redirect_url);
          });
      }
    },
    getJssdk: function(callback) {
      var url = location.href.split('#')[0];
      http({
        url: '/msg/center/get/jssdksign',
        type: 'GET',
        data: {
          appid: common.appId,
          url: url
        }
      }).then((r, er) => {
        console.log(r);
        callback(r.data);
      });
    }
  };
})();
export default weixin;
